import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { TableControls } from '../../BaseEditor';

// const StyleTD = styled.td`
//   padding: 2px 10px;
// `;

function RowKDB({
  row, rowSave,
}) {
  return (
    <TableRow
      hover
      sx={{ background: row.save ? '#baf3bab3' : 'white' }}
    >
      <TableCell sx={{ textAlign: 'center' }}>
        <TableControls.CheckboxInput
          noMargin
          value={row.save}
          onChange={() => rowSave(row.id, { save: !row.save })}
        />
      </TableCell>
      <TableCell>{row.kdb.code}</TableCell>
      <TableCell>
        {row.kdb.name}
      </TableCell>
    </TableRow>
  );
}
RowKDB.propTypes = {
  row: PropTypes.shape().isRequired,
  rowSave: PropTypes.func.isRequired,
};

export default memo(RowKDB);
